interface ContactModalProps {
  onClose: () => void;
}

export default function ContactModal({ onClose }: ContactModalProps) {
  const domain = 'kiedycogdzie.pl';
  const contactEmail = `${domain}@gmail.com`;

  const closeButtonClassName =
    'absolute top-[8px] right-[8px] z-[2147483647] inline-flex h-6 w-6 items-center justify-center rounded-full border text-white';

  return (
    <div
      id="contact-modal-overlay"
      className="fixed top-0 left-0 z-[2147483646] flex h-screen w-screen items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
      aria-label="Kontakt"
    >
      <div className="absolute inset-0 bg-black/35" onClick={onClose} aria-hidden="true" />

      <div
        id="contact-modal"
        className="relative w-[min(92vw,28rem)] p-6 text-slate-100"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          id="contact-modal-close"
          type="button"
          className={closeButtonClassName}
          onClick={onClose}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = 'rgba(11, 1, 54, 0.24)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#ea580c';
          }}
          style={{
            backgroundColor: '#ea580c',
            borderColor: '#ffffff',
            color: '#ffffff',
            width: '24px',
            height: '24px',
            minWidth: '24px',
            minHeight: '24px',
            padding: '0',
            lineHeight: '1',
          }}
          aria-label="Zamknij okno kontaktu"
        >
          <svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true">
            <line x1="1" y1="1" x2="9" y2="9" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
            <line x1="9" y1="1" x2="1" y2="9" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
          </svg>
        </button>

        <h3 className="text-lg font-semibold uppercase !text-base !text-slate-100">Kontakt</h3>

        <div aria-hidden="true" style={{ height: '20px' }} />

        <p id="contact-modal-description" className="mb-4 text-sm leading-relaxed text-slate-200">
          Masz pytania dotyczące serwisu {domain}? Chętnie pomożemy.
        </p>
        <div aria-hidden="true" style={{ height: '20px' }} />
        <p id="contact-modal-contact-info" className="mb-1 text-sm font-semibold text-white">Dane kontaktowe</p>
        <p
          id="contact-modal-email"
          className="inline-block text-sm text-white"
          style={{
            backgroundColor: 'rgb(234, 88, 12)',
            borderRadius: '9999px',
            padding: '4px 14px',
          }}
        >
          E-mail:{' '}
          <a
            href={`mailto:${contactEmail}`}
            className="font-medium text-white visited:text-white underline decoration-white/80 underline-offset-2 hover:text-white hover:decoration-white"
            style={{ color: '#ffffff' }}
          >
            {contactEmail}
          </a>
        </p>
      </div>
    </div>
  );
}
